import { useEffect } from 'react';
import { selectResourceId, selectUserName, selectProfilePicture } from '../../app/auth/createAuthSlice';
import { useAppSelector } from '../../app/hooks';
import { useGetOrCreateChatTokenMutation } from '../../app/appApiSlice';
import ActionableCardList from './ActionableCardList';
import HomeSlider from './HomeSlider';

const Home = () => {
const userName = useAppSelector(selectUserName);
const userProfilePicture = useAppSelector(selectProfilePicture);
const userResourceId = useAppSelector(selectResourceId);
const [getOrCreateChatToken] = useGetOrCreateChatTokenMutation();
const userEmail = useAppSelector((state) =>
  state.auth.appUserAccount?.data?.email ||
  state.auth.appUserAccount?.email ||
  state.auth.msGraphUser?.mail ||
  state.auth.msGraphUser?.userPrincipalName ||
  ""
);

useEffect(() => {
  const trimmedUserEmail = userEmail?.trim();
  if (!trimmedUserEmail) {
    return;
  }
  const trimmedDisplayName = userName?.trim() || undefined;
  const normalizedResourceId = typeof userResourceId === 'number' && userResourceId > 0
    ? userResourceId
    : undefined;

  getOrCreateChatToken({
    portalUserId: trimmedUserEmail,
    displayName: trimmedDisplayName,
    resourceId: normalizedResourceId,
    profilePictureUrl: userProfilePicture?.trim() || undefined,
  }).catch((error) => {
    console.error("Chat token initialization failed", error);
  });
}, [getOrCreateChatToken, userEmail, userName, userResourceId, userProfilePicture]);
return (
    <div className=" ">
      <div>
        <h1 className="text-xl font-semibold ">
          Hi {userName || ''},  <span className=" text-brand">Welcome to our Alumni Portal</span>
        </h1>
        <p className="text-sm text-subParaText font-regular mb-5">
          Your gateway to lifelong connections, new opportunities, and success stories from our global alumni community.
        </p>
      </div>

      {/* Homepage Slider */}
      <HomeSlider />

      {/** What's New section Actionable card item list */}
    
         <ActionableCardList /> 
    </div>
  );
};

export default Home;
